/** @flow */
import * as React from 'react';
import styled from 'styled-components';
import LinearProgress from 'material-ui/LinearProgress';

const Container = styled.div`
    background-color: white;
    ${({ position, theme }) => (position === 'TOP' ? `top: ${theme.metrics.navBarHeight}px;` : 'bottom: 0;')}
    box-shadow: ${({ theme }) => theme.colors.boxShadow}
    z-index: 1000;
    div:not(:last-child) {
      margin-right: ${({ theme }) => theme.metrics.margin}px;
    }
    padding: 0 ${({ theme }) => theme.metrics.largeMargin}px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: auto;
  height: ${({ theme }) => theme.metrics.actionBarHeight}px;
`;

type Props = {
  children: any,
  position: 'TOP' | 'BOTTOM',
  style?: Object,
  className?: string,

  progress?: { value: number, isIndeterminate?: boolean },
}

function progressBarMode(isIndeterminate?: boolean) {
  return isIndeterminate ? 'indeterminate' : 'determinate';
}

export default function FixedActionsBar({ children, position, style, className, progress }: Props) {
  return (
    <Container className="fixed-to-container" position={position}>
      {progress && <LinearProgress value={100 * progress.value} mode={progressBarMode(progress.isIndeterminate)} />}
      <Wrapper style={style} className={className}>
        {children}
      </Wrapper>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/common/components/FixedActionsBar.js